import { http, pagination } from 'utils'

import {
  SET_META,
  SET_INVENTORIES,
  ADD_INVENTORIES,
  SET_INVENTORY,
  RESET_INVENTORY
} from 'vx/mutations'

import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    inventories: [],
    inventory: {},
    meta: null
  },

  actions: {
    async getInventories ({ commit, state }, { params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      commit(ADD_INVENTORIES, [])
      const response = await http.get('inventories', { params })
      commit(ADD_INVENTORIES, response.data.data)
      commit(SET_META, response.data.meta)

      return response
    },

    resetInventories ({ commit }) {
      commit(SET_INVENTORIES, [])
      commit(SET_META, null)
    }
  },

  mutations: {
    [SET_INVENTORIES] (state, inventories) {
      state.inventories = inventories
    },

    [ADD_INVENTORIES] (state, inventories) {
      state.inventories = concat(state.inventories, inventories)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    },

    [RESET_INVENTORY] (state, inventory) {
      state.inventory = {}
    },

    [SET_INVENTORY] (state, inventory) {
      state.inventory = inventory
    }
  }
}
